<template>
  <v-container
    style="width: 100%;"
    fluid>
    <v-row>
      <v-col
        cols="12"
        class="px-0">
        <ReportFilter
          ref="ReportFilter"
          @handlerClickFilter="handlerClickFilter"
          @clearFilters="clearFilters"
          :resetFilterMyReports="resetFilterMyReports"
          :borderSelected="false"
          :isAdmissionMapReport="isAdmissionMapReport"
          :hideFinancialGroupFilter="hideFinancialGroupFilter"
          @hasFiltersMyReports="hasFiltersMyReports"
          @updateDates="updateDates"
        />
      </v-col>

      <v-col
        cols="12"
        class="pa-0">
        <ReportInfiniteScroll
          ref="MyReportInfiniteScroll"
          :filter="filterMyReports"
          :reportDefaultType="reportType"
          :reportLayoutName="reportLayoutName"
          :isAdmissionMapReport="isAdmissionMapReport"
          :fetchReports="fetchReports"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MovementRecordsMixin from '@/shared/mixins/movementRecords/movementRecordsMixin';
import GenericFunctionsMixin from '@/shared/mixins/genericFunctions/genericFunctionsMixin';
import InsuranceCarriersMixin from '@/shared/mixins/sdi/insuranceCarriersMixin';
import FinancialGroupsMixin from '@/shared/mixins/sdi/financialGroupsMixin';
import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';
import ReportFilter from '@/components/Report/ReportFilter.vue';
import ReportInfiniteScroll from '@/components/Report/ReportInfiniteScroll.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: "MyReport",

  components: {
    ReportFilter,
    ReportInfiniteScroll,
  },

  data: () => ({
    resetFilterMyReports: false,
    filterForCheckMyReports: {},
    financialGroups: [],
    dates: [],
  }),

  mixins: [
    MovementRecordsMixin,
    GenericFunctionsMixin,
    InsuranceCarriersMixin,
    FinancialGroupsMixin,
    ContractsMixin,
  ],

  props: {
    tab: {
      type: String,
    },
    reportType: {
      type: String,
      required: true,
    },
    reportLayoutName: {
      type: String,
    },
    isAdmissionMapReport: {
      type: Boolean,
      default: false,
    },
    fetchReports: {
      type: Function,
      default: null,
    },
    hideFinancialGroupFilter: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    tab: {
      handler(tabValue) {
        if (tabValue === 'reports') {
          const reportFilterRef = this.$refs.ReportFilter;

          if (reportFilterRef) reportFilterRef.handlerFilter();
        }
      },
    }
  },

  methods: {
    hasFilterValue(value) {
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'string') return value.trim() !== '';
      return value !== null && value !== undefined;
    },

    orderMyReportsFilter(filter = {}) {
      const orderedFilter = {};
      const hasFinancialGroup = this.hasFilterValue(filter.financialGroupId);
      const prioritizedKeys = hasFinancialGroup
        ? [ 'financialGroupId', 'status', 'receivingDateStart', 'receivingDateEnd' ]
        : [ 'status', 'receivingDateStart', 'receivingDateEnd' ];

      prioritizedKeys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(filter, key)) {
          orderedFilter[key] = filter[key];
        }
      });

      Object.keys(filter).forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(orderedFilter, key)) {
          orderedFilter[key] = filter[key];
        }
      });

      return orderedFilter;
    },

    setOrderedFilterMyReports(filter = {}) {
      this.filterMyReports = this.orderMyReportsFilter(filter);
    },

    handlerClickFilter(dates) {
      if (dates && dates.length > 0) {
        this.processDates(dates);

        const commonFilterProperties = {
          receivingDateStart: this.dates[0],
          receivingDateEnd: this.dates[1],
        };

        this.handleMyReports(commonFilterProperties);
      } else {
        this.dates = [];
      }
    },

    updateDates(dates) {
      this.processDates(dates);

      this.setOrderedFilterMyReports({
        ...this.filterMyReports,
        receivingDateStart: this.dates[0],
        receivingDateEnd: this.dates[1],
      });

      this.dataFilterMyReports = cloneDeep(this.filterMyReports);
    },

    processDates(dates) {
      const startDate = moment(dates[0]);
      const endDate = moment(dates[1]);

      this.dates[0] = this.setDateTimezone(startDate.startOf('day'))
      this.dates[1] = this.setDateTimezone(endDate.endOf('day').add(3, 'hours'))

      this.dates[0] = this.formatDate(this.dates[0])
      this.dates[1] = this.formatDate(this.dates[1])
    },

    setDateTimezone(date) {
      return date.add(3, 'hours')
    },

    formatDate(date) {
      return date.format('YYYY-MM-DDTHH:mm:ss.SSS');
    },

    clearFilters() {
      this.resetFilterMyReports = true;
    },

    handleMyReports(commonFilterProperties) {
      this.resetFilterMyReports = false;

      this.setOrderedFilterMyReports({
        ...this.dataFilterMyReports,
        ...commonFilterProperties,
      });

      setTimeout(() => {
        this.$refs.MyReportInfiniteScroll.handlerFilter(this.filterMyReports, 'click');
      }, 200);
    },

    hasFiltersMyReports(data) {
      this.dataFilterMyReports = this.orderMyReportsFilter(cloneDeep(data));

      this.setOrderedFilterMyReports({
        ...this.filterMyReports,
        ...this.dataFilterMyReports
      });
    },
  },

  async created() {
    if (!this.isAdmissionMapReport) {
      const initialRequests = [this.getInsuranceCarriers()];
      if (!this.hideFinancialGroupFilter) initialRequests.push(this.getFinancialGroups());
      await Promise.all(initialRequests);
    }
  },
}
</script>
